import React, { useState } from 'react';
import Footer from "./components/Footer.view";
import Header from "./components/Header.view";
import HeroSection from "./components/Hero.view";
import PopularMeals from "./components/Popular.view";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import MultiStepForm from "./components/multiForm/MultiForm.views";
import SummerCampForm from "./components/multiForm/SummerCampForm";

const isSummerCampRef = (ref) => {
  if (!ref) return false;
  try {
    const stored = JSON.parse(localStorage.getItem(ref) || "null");
    return (
      stored?.formType === "summer-camp" ||
      Boolean(stored?.guestStudentSchoolName) ||
      Array.isArray(stored?.menu_selection)
    );
  } catch {
    return false;
  }
};

function App() {
  const [activeForm, setActiveForm] = useState(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    return isSummerCampRef(ref) ? "summer" : "regular";
  });

  return (
    <div id="top">
      <Header />

      <main>
        <article>
          {/* Pass the function to switch forms */}
          <HeroSection onFormChange={setActiveForm} activeForm={activeForm} />
          
          <PopularMeals />
          
          {/* Conditional Layout Rendering */}
          <section id="registration-section">
            {activeForm === 'regular' && <MultiStepForm />}
            {activeForm === 'summer' && <SummerCampForm />}
          </section>

          <Footer />
          <ToastContainer />
        </article>
      </main>
    </div>
  );
}

export default App;